import * as React from 'react'
import { IMemberSearchObject } from '../../types/index'

import Modal from '../ui/Modal'

export interface ITeamMemberArchiveUserModalProps {
  teamMember: IMemberSearchObject
  onArchiveClick: (teamMember: IMemberSearchObject) => Promise<any>
  onClose: () => void
}

interface IArchiveUserState {
  isPending: boolean
  error: string
}

class TeamMemberArchiveUserModal extends React.Component<ITeamMemberArchiveUserModalProps, IArchiveUserState> {
  constructor(props: ITeamMemberArchiveUserModalProps) {
    super(props)
    this.state = {
      isPending: false,
      error: ''
    }
  }

  public render() {
    const { teamMember } = this.props
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='TeamMemberArchive bg-white col-3 p2'>
            <div className='flex flex-column items-center'>
              <span className='pt1 font-dark-grey'>Are you sure you want to move</span>
              <span className='pt02 h2 font-dark-grey'>{teamMember && teamMember.name}</span>
              <span className='pt02 font-dark-grey'>to Archive?</span>
            </div>

            <div className='flex flex-column items-center mt3'>
              <span>
                <span className='weight-600'>Note: </span>
                <span className='weight-300'>The user will not be able to log in</span>
              </span>
              <span>and use Goin</span>
            </div>

            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={this.handleCancelClick}
                className='btn bg-white rounded font-light-grey mr2'
              >
                Cancel
              </button>

              <button
                type='button'
                disabled={this.state.isPending}
                onClick={this.handleSubmitClick}
                className='btn bg-orange rounded font-white'
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }

  private handleSubmitClick = () => {
    this.setState({ isPending: true, error: '' })
    this.props
      .onArchiveClick(this.props.teamMember)
      .then(() => this.props.onClose())
      .catch(error => {
        this.setState({ isPending: false, error })
        console.log(error)
      })
  }
}

export default TeamMemberArchiveUserModal



// WEBPACK FOOTER //
// ./src/components/team-members/TeamMemberArchiveUserModal.tsx